export const getPost = async (id) => {
  const response = await fetch(
    `https://news.energysalesdirect.com/api/v1/posts/${id}/`
  );
  const result = await response.json();
  return {
    ...result,
    source: result.source.title,
    folder: result.folder && result.folder.replaceAll("/", ""),
    fotourl: result.fotourl,
    source: result.source.title,
  };
};

export const getCountries = async () => {
  const response = await fetch(
    "https://news.energysalesdirect.com/api/v1/countries/data/"
  );
  const result = await response.json();
  return result;
};

export const PostNews = async (data, another) => {
  //delete data.source;
  let method = data.id ? "PUT" : "POST";
  await fetch("https://news.energysalesdirect.com/api/v1/cockpit/emp_news/", {
    method: method,
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((r) => r.json())
    .then((d) => {
      if (another) {
        localStorage.setItem("newstitle", d.title);
        localStorage.setItem("newsid", d.id);
        window.location.href = "/newpostedit/0";
      } else {
        localStorage.removeItem("newstitle");
        localStorage.removeItem("newsid");
        window.location.href = "/admin/posts/post/";
      }
    });
};

export async function EmpLogin(obj) {
  return await fetch(
    "https://www.energymarketprice.com/siteapi/Administration/account/token",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(obj),
    }
  )
    .then((r) => r.json())
    .then((data) => data);
}

export async function ValidateToken(obj) {
  return await fetch(
    "https://cockpit.energymarketprice.com/api/Auth/TokenValidation/",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(obj),
    }
  )
    .then((r) => r.json())
    .then((d) => d);
}

export async function getOpenAI(text, lang, type = 0, title = 0) {
  let token = window.localStorage.getItem("authToken");
  let localText = "";
  let response = null;

  if (title === 1) {
    localText = `Translate in ${lang} and give as response only my text without extra sentences and extra symbols: ${text}`;
  } else {
    localText = `Translate in ${lang}. Ensure that the paragraphs are separated by blank 
  lines and that your response contains only the requested translated text, without extra sentences and extra symbols.\r\r ${text}`;
  }

  if (type === 1) {
    if (title === 1) {
      localText = `Paraphrase in ${lang} and give as response only my text without extra sentences and extra symbols: ${text}`;
    } else {
      localText = `Paraphrase in ${lang}. Ensure that the paragraphs are separated by blank 
  lines and that your response contains only the requested paraphrased text, without extra sentences and extra symbols.\r\r ${text}`;
    }
  }

  if (type === 2)
    localText = `Please provide a 3-4 paragraph summary in ${lang} language. Ensure that the paragraphs are separated by blank 
  lines and that your response contains only the requested summary text, without extra sentences and extra symbols.\r\r ${text}`;

  await fetch("https://news.energysalesdirect.com/api/v1/cockpit/openai/", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      text: localText,
    }),
  })
    .then((r) => r.json())
    .then((data) => {
      response = data.response;
    });

  return response;
}
